<div class="chart-info">
  <p>{{translationsService.translate(settings["GraphTitle"])}}</p>
  <p>{{translationsService.translate(settings["GraphSubTitle"])}}</p>
</div>

<sem-loader class="sided-50" [showLoader]="loading"></sem-loader>

@if (!loading) {
  <ngx-charts-line-chart
    [view]="view"
    [scheme]="colorScheme"
    [legend]="legend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [timeline]="false"
    [results]="multi"
    [rotateXAxisTicks]="rotateXAxisTicks"
    (select)="onSelect($event)"
    (activate)="onActivate($event)"
    (deactivate)="onDeactivate($event)"
    #chartContainer>
  </ngx-charts-line-chart>
}
